import { motion } from "framer-motion";

export const LogoMark = ({ size = 24, animated = false, className = "" }) => {
    const draw = (delay, duration = 1.1) =>
        animated
            ? {
                  initial: { pathLength: 0 },
                  animate: { pathLength: 1 },
                  transition: { duration, ease: [0.65, 0, 0.35, 1], delay },
              }
            : {};

    return (
        <motion.svg
            data-testid="logo-mark"
            width={size}
            height={size}
            viewBox="0 0 32 32"
            fill="none"
            className={className}
            aria-hidden="true"
        >
            <motion.path
                d="M16 2.5 L29.5 16 L16 29.5 L2.5 16 Z"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinejoin="round"
                {...draw(0.1)}
            />
            <motion.path
                d="M16 9.5 L22.5 16 L16 22.5 L9.5 16 Z"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinejoin="round"
                {...draw(0.55, 0.8)}
            />
            <motion.circle
                cx="16"
                cy="16"
                r="1.7"
                fill="currentColor"
                style={{ transformOrigin: "center" }}
                {...(animated
                    ? {
                          initial: { scale: 0, opacity: 0 },
                          animate: { scale: 1, opacity: 1 },
                          transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1], delay: 1.15 },
                      }
                    : {})}
            />
        </motion.svg>
    );
};
